import { RouteObject } from "react-router-dom"
import AuthGuard from "../../../shared/auth/component/auth"

import DashBoardComponent from "../page/dashboard-page"
const DashBoardRoute: RouteObject = {
  path: "/",
  element: (
    <AuthGuard>
      <DashBoardComponent />
    </AuthGuard>
  ),
}

export { DashBoardRoute }
